import type { InvestmentTimelineItem } from "@interfaces/investment";
import { formatDate, numberToCurrency } from "@components/utils/formatters";

import React from "react";

import * as Styled from "./Styled";
import { TimelineItemDetails } from "./itemDetails";

type Props = {
  timelineItems: InvestmentTimelineItem[];
  shareName: string;
};

export const InvestmentTimeline: React.FC<Props> = ({
  timelineItems,
  shareName,
}) => {
  const timelineLabels = {
    acquisition: `${shareName}s Adquiridas`,
    payment: "Investimento Realizado",
    redemption: "Resgate",
    reinvestment: "Reinvestimento",
    estimated_deadline: "Prazo Estimado",
  };

  const lastCompletedIndex = timelineItems.reduce(
    (lastIndex, item, index) => (item.date ? index : lastIndex),
    -1,
  );

  return (
    <Styled.TimelineWrapper>
      <Styled.TimelineTrack
        lastCompletedIndex={lastCompletedIndex}
        total={timelineItems.length}
      >
        {timelineItems.map(({ type, date, value, details }, index) => (
          <Styled.TimelineItem key={index} pending={!date}>
            <Styled.TimelineDot />

            <Styled.TimelineCard>
              <Styled.CardLabel>{timelineLabels[type]}</Styled.CardLabel>

              {date && <Styled.CardDate>{formatDate(date)}</Styled.CardDate>}

              <Styled.CardValue>
                {typeof value === "number" ? numberToCurrency(value) : value}
              </Styled.CardValue>

              {details && <TimelineItemDetails type={type} details={details} />}
            </Styled.TimelineCard>
          </Styled.TimelineItem>
        ))}
      </Styled.TimelineTrack>
    </Styled.TimelineWrapper>
  );
};
